module.exports = __webpack_public_path__ + "static/media/success.545a7e92.svg";